import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminUsersList(filters, page, pageSize = 50) {
    return useQuery({
        queryKey: adminKeys.usersList(filters, page),
        queryFn: () => adminApi.listUsers(filters, page, pageSize),
    });
}
